export enum ProjectTypes {
  CLASSIC = 'classic',
  PASSWORDLESS = 'passwordless',
  SOCIAL = 'social',
  SHADOW = 'shadow'
}

export enum StorageTypes {
  XSOLLA = 'xsolla',
  FIREBASE = 'firebase',
  PLAYFAB = 'playfab',
  CUSTOM = 'custom'
}

export enum TestTypes {
  USERS_STORAGE = 'users_storage'
}

export type BrowserName = 'chromium' | 'firefox' | 'webkit';
type ProjectMap = Record<`${BrowserName}-${ProjectTypes | StorageTypes | TestTypes}`, string>;

// Map for separate Login projects per browser (for parallel tests execution)
export const getProjectId = (
  browserName: BrowserName,
  projectType: ProjectTypes | StorageTypes | TestTypes
): string => {
  const projectIdMap: ProjectMap = {
    'chromium-classic': 'b7ff3752-c15c-11ec-8589-42010aa80004',
    'chromium-passwordless': '0e69790e-c1fc-11ec-8589-42010aa80004',
    'chromium-social': '1ec0e768-c1fc-11ec-8589-42010aa80004',
    'chromium-shadow': 'cd259ebb-c15c-11ec-8589-42010aa80004',
    'chromium-xsolla': '249454ca-d761-11ec-8589-42010aa80004',
    'chromium-firebase': '5752c32e-d761-11ec-8589-42010aa80004',
    'chromium-playfab': 'cea39a1d-d76c-11ec-8589-42010aa80004',
    'chromium-custom': '334be68f-d76d-11ec-8589-42010aa80004',
    'firefox-classic': 'bd38b38d-c223-11ec-8589-42010aa80004',
    'firefox-passwordless': 'cda3e1f9-c223-11ec-8589-42010aa80004',
    'firefox-social': 'dcde2511-c223-11ec-8589-42010aa80004',
    'firefox-shadow': '05d681de-c224-11ec-8589-42010aa80004',
    'firefox-xsolla': '342ec9d0-d761-11ec-8589-42010aa80004',
    'firefox-firebase': 'a83e4ae7-d76c-11ec-8589-42010aa80004',
    'firefox-playfab': 'df20ee0d-d76c-11ec-8589-42010aa80004',
    'firefox-custom': '4bb69f43-d76d-11ec-8589-42010aa80004',
    'webkit-classic': '17ec881b-c224-11ec-8589-42010aa80004',
    'webkit-passwordless': '28c69cdc-c224-11ec-8589-42010aa80004',
    'webkit-social': '3c6abcab-c224-11ec-8589-42010aa80004',
    'webkit-shadow': '565bba12-c224-11ec-8589-42010aa80004',
    'webkit-xsolla': '3ff6a27c-d761-11ec-8589-42010aa80004',
    'webkit-firebase': 'b81aca8e-d76c-11ec-8589-42010aa80004',
    'webkit-playfab': '1cdf9012-d76d-11ec-8589-42010aa80004',
    'webkit-custom': '5b1ea95a-d76d-11ec-8589-42010aa80004',
    'chromium-users_storage': '86660bed-f136-11ec-b9f0-42010aa80004',
    'firefox-users_storage': 'ae3599db-f136-11ec-b9f0-42010aa80004',
    'webkit-users_storage': 'ce12606e-f136-11ec-b9f0-42010aa80004'
  };

  return projectIdMap[`${browserName}-${projectType}`];
};

type ProjectMapWithoutAgreement = Record<`${BrowserName}-classic`, string>;
export const getProjectIdWithoutAgreement = (browserName: BrowserName): string => {
  const projectIdMap: ProjectMapWithoutAgreement = {
    'chromium-classic': 'a17cb081-ee36-11ec-b9f0-42010aa80004',
    'firefox-classic': 'b74fdb42-ee36-11ec-b9f0-42010aa80004',
    'webkit-classic': 'd34cf6d5-ee36-11ec-b9f0-42010aa80004'
  };

  return projectIdMap[`${browserName}-classic`];
};
